import React from "react";

const MAP = {
  open: "bg-sky-100 text-sky-900 border-sky-200",
  closed: "bg-emerald-100 text-emerald-900 border-emerald-200",
  flagged: "bg-rose-100 text-rose-900 border-rose-200",
  ok: "bg-emerald-100 text-emerald-900 border-emerald-200",
  warning: "bg-amber-100 text-amber-950 border-amber-200",
  danger: "bg-rose-100 text-rose-900 border-rose-200",
};

const LABEL = { open: "Open", closed: "Closed", flagged: "Red flag" };

export const StatusBadge = ({ status, children, className = "" }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${MAP[status] || MAP.open} ${className}`}
  >
    {children || LABEL[status] || status}
  </span>
);
